import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '../../../services/axiosBaseQuery';

export const emptySplitApi = createApi({
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Stock', 'Iccid', 'NumberDiscovery', 'History', 'TransferOwnership', 'AdvancedFeatures'],
  reducerPath: 'stockApi',
  endpoints: () => ({}),
});
